import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardBody, CardTitle } from "reactstrap";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { BASE_URL } from '../../constants.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const InspectionChart = () => {
  const [chartLine, setChartLine] = useState({ labels: [], datasets: [] });

  const fetchInspectionData = () => {
    const token = localStorage.getItem('token');
    if (token) {
      fetch(`${BASE_URL}/inspection`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => response.json())
        .then(data => {
          console.log(data, 'inspectiondata');
          if (data.status) {
            processInspectionData(data.result.data);
          } else {
            console.error("Error: Unable to fetch inspection data.");
          }
        })
        .catch(error => console.error("Error fetching data:", error));
    } else {
      console.error("Error: Authorization token is missing.");
    }
  };

  const processInspectionData = (inspectionData) => {
    const now = new Date();
    const last14Days = Array.from({ length: 14 }, (_, i) => {
      const date = new Date(now);
      date.setDate(now.getDate() - i);
      // Format date as MM/DD/YYYY
      return date.toLocaleDateString('en-US');
    }).reverse();

    const inspectionsInLast14Days = inspectionData.filter(item => {
      const inspectionDate = new Date(item.created_at).toLocaleDateString('en-US'); // Format inspection date
      return last14Days.includes(inspectionDate);
    });

    const dataCounts = last14Days.reduce((acc, date) => {
      acc[date] = 0;
      return acc;
    }, {});

    inspectionsInLast14Days.forEach(item => {
      const date = new Date(item.created_at).toLocaleDateString('en-US'); // Format date as MM/DD/YYYY
      dataCounts[date] += 1;
    });

    const uniqueLabels = Object.keys(dataCounts);
    const dataValues = Object.values(dataCounts);

    setChartLine({
      labels: uniqueLabels,
      datasets: [
        {
          label: "Number of Inspections",
          data: dataValues,
          fill: false,
          borderColor: "#2E6A54",
          tension: 0.1,
        },
      ],
    });
  };

  useEffect(() => {
    fetchInspectionData();
  }, []);

  return (
    <Card>
      <CardHeader>
        <CardTitle tag="h5">Inspections</CardTitle>
        <p className="card-category">Last 14 Days progress</p>
      </CardHeader>
      <CardBody style={{paddingBottom:'30px'}}>
        <Line
          data={chartLine}
          width={400}
          height={100}
        />
      </CardBody>
    </Card>
  );
}

export default InspectionChart;
